import { render, staticRenderFns } from "./yishengjieshao.vue?vue&type=template&id=603187cc&scoped=true"
import script from "./yishengjieshao.vue?vue&type=script&lang=js"
export * from "./yishengjieshao.vue?vue&type=script&lang=js"
import style0 from "./yishengjieshao.vue?vue&type=style&index=0&id=603187cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603187cc",
  null
  
)

export default component.exports